'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FloatingActionButton = require('./FloatingActionButton');

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FloatingActionButton2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/FloatingActionButton/index.js
 ** module id = 1205
 ** module chunks = 0
 **/